import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { AlertCircle, ArrowRight } from 'lucide-react';

import LayoutAuth from '../components/layoutAuth';
import { authService } from '../services/auth';
import { getParameterByName } from '../utils/urls';

const inputClass =
  'mt-2 block w-full rounded-xl border border-white/10 bg-beachvision-elevated px-4 py-3 text-sm text-white placeholder:text-beachvision-muted focus:border-beachvision-teal focus:outline-none focus:ring-2 focus:ring-beachvision-teal/30';

const Login = ({ authenticated }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (authenticated) {
    return <Navigate to="/dashboard/" replace />;
  }

  const submitForm = (e) => {
    e.preventDefault();
    setLoading(true);

    authService.login(
      e.target.elements.email.value,
      e.target.elements.password.value,
      () => {
        setError(null);
        authService.fetchUser(
          () => {
            const next = getParameterByName('next', window.location);
            window.location = next || '/dashboard/';
          },
          () => {
            console.error('Failed to fetch user info');
          }
        );
      },
      (requestError) => {
        setError(
          requestError?.response?.data?.detail || 'Could not log in. Please try again.'
        );
        setLoading(false);
      }
    );
  };

  return (
    <LayoutAuth
      title="Welcome back"
      subtitle="Sign in to continue reviewing your sessions and training progress."
    >
      <form className="space-y-5" action="#" onSubmit={submitForm}>
        {error ? (
          <div className="rounded-xl border border-red-400/30 bg-red-500/10 p-3 text-sm text-red-200 flex items-start gap-2">
            <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
            <p>{error}</p>
          </div>
        ) : (
          ''
        )}

        <div>
          <label htmlFor="email" className="text-sm font-semibold text-beachvision-primary-light">
            Email address
          </label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            className={inputClass}
            placeholder="name@email.com"
          />
        </div>

        <div>
          <label htmlFor="password" className="text-sm font-semibold text-beachvision-primary-light">
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            className={inputClass}
            placeholder="Enter your password"
          />
        </div>

        <button
          type="submit"
          className="cursor-pointer mt-1 w-full rounded-xl bg-beachvision-cta px-4 py-3 font-display font-black uppercase tracking-wide text-beachvision-on-coral shadow-lg shadow-beachvision-coral/20 transition hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-60"
          disabled={loading}
        >
          <span className="inline-flex items-center gap-2">
            {loading ? 'Signing in...' : 'Sign in'}
            {!loading && <ArrowRight className="h-4 w-4" />}
          </span>
        </button>
      </form>

      <p className="mt-6 text-center text-sm text-beachvision-muted">
        No account yet?{' '}
        <Link to="/register/" className="font-semibold text-beachvision-teal hover:text-beachvision-primary-light">
          Create one
        </Link>
      </p>
    </LayoutAuth>
  );
};

export default Login;
